<template>
    <div class="product-box">
        <div class="head-box"><navBar></navBar></div>
        <div class="content">
            <!-- 数字化连锁拓店管理系统 -->
            <div class="banner-box">
                <div class="bag">
                    <!-- pc -->
                    <img v-img="{ form: form.bannerObj, key: 'img' }" :src="form.bannerObj.img" alt="" />
                    <!-- mobile -->
                    <!-- <img src="../../assets/cloudProduct/banner_pro.jpg" alt=""> -->
                </div>
                <div class="container1">
                    <div class="img-text">
                        <div class="left-box  wow fadeInUp">
                            <p class="name pingFang-Bold font50" v-edit="{ form: form.bannerObj, key: 'title' }">{{ form.bannerObj.title }}</p>
                            <p class="tip-text pingFang-Regular font26" v-edit="{ form: form.bannerObj, key: 'smallTitle' }">{{ form.bannerObj.smallTitle }}</p>
                            <p class="describe font20" v-edit="{ form: form.bannerObj, key: 'content' }">
                                {{ form.bannerObj.content }}
                            </p>
                            <div class="button-box">
                                <div @click="showToggle" class="but" v-edit="{ form: form.bannerObj, key: 'leftButtonContent' }">
                                    <span>{{ form.bannerObj.leftButtonContent }}</span>
                                    <i class="arrow el-icon-d-arrow-right"></i>
                                </div>
                                <!-- <div @click="jumpPage('https://saas.sscanmou.com/login', 'a')" class="cursor but">
                                    <span v-edit="{ form: form.bannerObj, key: 'rightButtonContent' }">{{ form.bannerObj.rightButtonContent }}</span>
                                    <i class="arrow el-icon-d-arrow-right"></i>
                                </div> -->
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 助力品牌拓店全流程数字化 -->
            <div class="cell-box ptb120">
                <div class="container1">
                    <div class="wow fadeInUp">
                        <p class="box-title pingFang-Bold font40" v-edit="{ form: form.firstObj, key: 'title' }">{{ form.firstObj.title }}</p>
                        <p class="tips pingFang-Regular font24" v-edit="{ form: form.firstObj, key: 'content' }">{{ form.firstObj.content }}</p>
                    </div>
                    <div class="module-box">
                        <div class="module module-hover wow fadeInUp" v-for="(item, key) in form.firstObj.list" :key="key">
                            <div class="m-img"><img :src="item.img" v-img="{ form: item, key: 'img' }" /></div>
                            <p class="module-title pingFang-Heavy font26" v-edit="{ form: item, key: 'title' }">{{ item.title }}</p>
                            <p class="text" v-edit="{ form: item, key: 'content' }">{{ item.content }}</p>
                            <div class="but-box">
                                <el-button v-edit="{ form: item, key: 'buttonContent' }" class="but understand-details" type="primary" round @click="showToggle">
                                    {{ item.buttonContent }}&nbsp;
                                    <span class="arrow el-icon-d-arrow-right"></span>
                                </el-button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="tab-menu-ul font18" id="tabMenuLi">
                <ul>
                    <li v-edit="{ form: form.fixedObj, key: key }" class="text text-model pointer" v-for="(item, key) in form.fixedObj" :key="key" :data-index="key + 1 + ''">
                        {{ item }}
                    </li>
                    <li id="backToTop" class="arrow-top pointer"><img src="../../assets/cloudProduct/gotop.png" /></li>
                </ul>
            </div>
            <!-- 工具+数据+模型，标准化SaaS系统 -->
            <div id="cloudHome1" class="ptb120 tab-show-box tab-show-box-top-padding">
                <div class="container1">
                    <div class="boxTitleTips  wow fadeInUp">
                        <p class="box-title pingFang-Bold font50" v-edit="{ form: form.secoundObj, key: 'title' }">{{ form.secoundObj.title }}</p>
                        <p class="tips pingFang-Medium font24" v-edit="{ form: form.secoundObj, key: 'content' }">{{ form.secoundObj.content }}</p>
                    </div>
                    <div class="flexcolumn  wow fadeInUp">
                        <p class="tabs-title pingFang-Heavy font36" v-edit="{ form: form.secoundObj, key: 'smallTitle' }">{{ form.secoundObj.smallTitle }}</p>
                        <div class="tab-show-content">
                            <div class="show-tabs management-tool">
                                <el-tabs :stretch="true" v-model="managementTool" type="border-card">
                                    <el-tab-pane
                                        v-edit="{ form: item, key: 'title' }"
                                        :label="item.title"
                                        :name="item.title"
                                        v-for="(item, key) in form.secoundObj.list"
                                        :key="key"
                                    >
                                        <itemAdd :list="form.secoundObj.list" :itemIndex="key"></itemAdd>
                                        <div class="tab-pan-content animate-fadeInUp-module">
                                            <div class="text">
                                                <p class="tab-name pingFang-Heavy font20" v-edit="{ form: item, key: 'title' }">{{ item.title }}</p>
                                                <p class="title pingFang-Medium font30" v-edit="{ form: item, key: 'bigTitle' }">{{ item.bigTitle }}</p>
                                                <div class="icon-text-box">
                                                    <div class="icon-text" v-for="(items, keys) in item.list" :key="keys">
                                                        <img src="../../assets/cloudProduct/dot.png" alt="" />
                                                        <p class="describe" v-edit="{ form: item.list, key: keys }">{{ items }}</p>
                                                        <itemAdd :list="item.list" :itemIndex="keys"></itemAdd>
                                                    </div>
                                                </div>
                                                <div class="button-box">
                                                    <el-button v-edit="{ form: item, key: 'leftBotton' }" class="but understand-details" type="primary" round @click="showToggle">
                                                        {{ item.leftBotton }}&nbsp;
                                                        <span class="arrow el-icon-d-arrow-right"></span>
                                                    </el-button>
                                                    <!-- <div
                                                        @click="jumpPage('https://saas.sscanmou.com/login', 'a')"
                                                        class="cursor but yellow-style understand-details"
                                                        type="primary"
                                                        round
                                                    >
                                                        <span v-edit="{ form: item, key: 'rightButton' }">{{ item.rightButton }}</span>
                                                        <span class="arrow el-icon-d-arrow-right"></span>
                                                    </div> -->
                                                </div>
                                            </div>
                                            <div class="show-img" v-img="{ form: item, key: 'img' }"><img :src="item.img" alt="" /></div>
                                        </div>
                                    </el-tab-pane>
                                </el-tabs>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 全域（线上+线下）商业大数据 -->
            <div id="cloudHome2" class=" tab-show-box">
                <div class="container1">
                    <p class="tabs-title font36 wow fadeInUp" v-edit="{ form: form.thiredObj, key: 'smallTitle' }">{{ form.thiredObj.smallTitle }}</p>
                    <div class="tab-show-content wow fadeInUp">
                        <div class="show-tabs">
                            <el-tabs v-model="bigData" type="border-card">
                                <el-tab-pane v-edit="{ form: item, key: 'title' }" :label="item.title" :name="item.title" v-for="(item, key) in form.thiredObj.list" :key="key">
                                    <div class="tab-pan-content animate-fadeInUp-module">
                                        <div class="text">
                                            <p class="tab-name font20" v-edit="{ form: item, key: 'title' }">{{ item.title }}</p>
                                            <p class="title font30" v-edit="{ form: item, key: 'bigTitle' }">{{ item.bigTitle }}</p>

                                            <div class="icon-text-box">
                                                <div class="icon-text">
                                                    <p class="describe" v-edit="{ form: item, key: 'content' }">{{ item.content }}</p>
                                                </div>
                                            </div>
                                            <div class="button-box">
                                                <el-button v-edit="{ form: item, key: 'leftBotton' }" class="but understand-details" type="primary" round @click="showToggle">
                                                    {{ item.leftBotton }}&nbsp;
                                                    <span class="arrow el-icon-d-arrow-right"></span>
                                                </el-button>
                                                <!-- <div
                                                    @click="jumpPage('https://saas.sscanmou.com/login', 'a')"
                                                    class="cursor but yellow-style understand-details"
                                                    type="primary"
                                                    round
                                                >
                                                    <span v-edit="{ form: item, key: 'rightButton' }">{{ item.rightButton }}</span>
                                                    <span class="arrow el-icon-d-arrow-right"></span>
                                                </div> -->
                                            </div>
                                        </div>
                                        <div class="show-img" v-img="{ form: item, key: 'img' }"><img :src="item.img" alt="" /></div>
                                    </div>
                                </el-tab-pane>
                            </el-tabs>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 个性化品牌精准适配模型 -->
            <div id="cloudHome3" class="pb120 tab-show-box">
                <div class="container1">
                    <p class="tabs-title font36 wow fadeInUp" v-edit="{ form: form.fourthObj, key: 'smallTitle' }">{{ form.fourthObj.smallTitle }}</p>
                    <div class="tab-show-content wow fadeInUp">
                        <div class="show-tabs personalized-show-tabs">
                            <el-tabs v-model="fitModel" type="border-card">
                                <template v-for="(item, key) in form.fourthObj.list">
                                    <el-tab-pane v-edit="{ form: item, key: 'title' }" :label="item.title" :name="item.title" v-if="key == 0">
                                        <div class="tab-pan-content animate-fadeInUp-module">
                                            <div class="text" style="transform: translateY(-10px);">
                                                <p class="tab-name font20" v-edit="{ form: item, key: 'title' }">{{ item.title }}</p>
                                                <p class="title font30" v-edit="{ form: item, key: 'bigTitle' }">{{ item.bigTitle }}</p>
                                                <div class="icon-text-box">
                                                    <div class="icon-text">
                                                        <p class="describe" v-edit="{ form: item, key: 'content' }">
                                                            {{ item.content }}
                                                        </p>
                                                    </div>
                                                </div>
                                                <div class="button-box">
                                                    <el-button v-edit="{ form: item, key: 'leftBotton' }" class="but understand-details" type="primary" round @click="showToggle">
                                                        {{ item.leftBotton }}&nbsp;
                                                        <span class="arrow el-icon-d-arrow-right"></span>
                                                    </el-button>
                                                    <!-- <el-button
                                                        v-edit="{ form: item, key: 'rightButton' }"
                                                        class="but yellow-style understand-details"
                                                        type="primary"
                                                        round
                                                        @click=""
                                                    >
                                                        {{ item.rightButton }}&nbsp;
                                                        <span class="arrow el-icon-d-arrow-right"></span>
                                                    </el-button> -->
                                                </div>
                                            </div>
                                            <div class="show-img" v-img="{ form: item, key: 'img' }"><img :src="item.img" alt="" /></div>
                                        </div>
                                    </el-tab-pane>
                                    <el-tab-pane v-edit="{ form: item, key: 'title' }" :label="item.title" :name="item.title" v-if="key == 1">
                                        <div class="tab-pan-content animate-fadeInUp-module">
                                            <div class="text" style="transform: translateY(-100px);">
                                                <p class="tab-name font20" v-edit="{ form: item, key: 'title' }">{{ item.title }}</p>
                                                <p class="title font30" v-edit="{ form: item, key: 'bigTitle' }">{{ item.bigTitle }}</p>
                                                <div class="icon-text-box">
                                                    <div class="icon-text">
                                                        <p class="describe" v-edit="{ form: item, key: 'content' }">
                                                            {{ item.content }}
                                                        </p>
                                                    </div>
                                                </div>
                                                <div class="button-box">
                                                    <el-button v-edit="{ form: item, key: 'leftBotton' }" class="but understand-details" type="primary" round @click="showToggle">
                                                        {{ item.leftBotton }}&nbsp;
                                                        <span class="arrow el-icon-d-arrow-right"></span>
                                                    </el-button>
                                                    <!-- <div
                                                        @click="jumpPage('https://saas.sscanmou.com/login', 'a')"
                                                        class="cursor but yellow-style understand-details"
                                                        type="primary"
                                                        round
                                                    >
                                                        <span v-edit="{ form: item, key: 'rightButton' }">{{ item.rightButton }}</span>
                                                        <span class="arrow el-icon-d-arrow-right"></span>
                                                    </div> -->
                                                </div>
                                            </div>
                                            <div class="show-img" v-img="{ form: item, key: 'img' }"><img :src="item.img" alt="" /></div>
                                        </div>
                                    </el-tab-pane>
                                    <el-tab-pane v-edit="{ form: item, key: 'title' }" :label="item.title" :name="item.title" v-if="key == 2">
                                        <div class="tab-pan-content animate-fadeInUp-module">
                                            <div class="text" style="transform: translateY(-122px);">
                                                <p class="tab-name font20" v-edit="{ form: item, key: 'title' }">{{ item.title }}</p>
                                                <p class="title font30" v-edit="{ form: item, key: 'bigTitle' }">{{ item.bigTitle }}</p>
                                                <div class="icon-text-box">
                                                    <div class="icon-text">
                                                        <p class="describe" v-edit="{ form: item, key: 'content' }">
                                                            {{ item.content }}
                                                        </p>
                                                    </div>
                                                </div>
                                                <div class="button-box">
                                                    <el-button v-edit="{ form: item, key: 'leftBotton' }" class="but understand-details" type="primary" round @click="showToggle">
                                                        {{ item.leftBotton }}&nbsp;
                                                        <span class="arrow el-icon-d-arrow-right"></span>
                                                    </el-button>
                                                    <!-- <el-button
                                                        v-edit="{ form: item, key: 'rightButton' }"
                                                        class="but yellow-style understand-details"
                                                        type="primary"
                                                        round
                                                        @click=""
                                                    >
                                                        {{ item.rightButton }}&nbsp;
                                                        <span class="arrow el-icon-d-arrow-right"></span>
                                                    </el-button> -->
                                                </div>
                                            </div>
                                            <div class="show-img" v-img="{ form: item, key: 'img' }"><img :src="item.img" alt="" /></div>
                                        </div>
                                    </el-tab-pane>
                                </template>
                            </el-tabs>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 产品应用蓝图 -->
            <div class=" product-blueprint-box ptb120">
                <p class="box-title font40 wow fadeInUp" v-edit="{ form: form.fifthObj, key: 'title' }">{{ form.fifthObj.title }}</p>
                <div class="product-blueprint-content wow fadeInUp">
                    <div class="blueprint"><img :src="form.fifthObj.img" v-img="{ form: form.fifthObj, key: 'img' }" /></div>
                </div>
            </div>
            <!-- 众多行业用户的信赖之选 -->
            <div class=" tabs-box ptb120" id="trust-of-choice">
                <div class="container1">
                    <div class=" wow fadeInUp">
                        <p class="box-title font40" v-edit="{ form: form.sixthObj, key: 'title' }">{{ form.sixthObj.title }}</p>
                        <p class="tips">&nbsp;</p>
                    </div>
                    <el-tabs v-model="activeName" class="wow fadeInUp">
                        <el-tab-pane
                            v-edit="{ form: item, key: 'tableTitle' }"
                            v-for="(item, key) in form.sixthObj.list"
                            :key="key"
                            :label="item.tableTitle"
                            :name="key + ''"
                        ></el-tab-pane>
                    </el-tabs>
                    <div class="fz_cont wow fadeInUp">
                        <div :class="activeName == key ? 'tabs-content-box active' : 'tabs-content-box'" v-for="(item, key) in form.sixthObj.list" :key="key">
                            <itemAdd :list="form.sixthObj.list" :itemIndex="key"></itemAdd>
                            <div class="name-logo-box">
                                <div class="head-portrait">
                                    <img class="head-portrait-img" :src="item.img" v-img="{ form: item, key: 'img' }" />
                                    <div class="name-introduction">
                                        <p class="name font24" v-edit="{ form: item, key: 'title' }">{{ item.title }}</p>
                                        <p class="introduction" v-edit="{ form: item, key: 'smallTitle' }">{{ item.smallTitle }}</p>
                                    </div>
                                </div>
                                <div class="r-logo-img"><img :src="item.logo" v-img="{ form: item, key: 'logo' }" /></div>
                            </div>
                            <div class="introduction-content" v-edit="{ form: item, key: 'content' }">{{ item.content }}</div>
                            <div class="button-text-box pointer">
                                <span v-edit="{ form: item, key: 'button' }">{{ item.button }}</span>
                                <div class="round-arrow" @click="showToggle">
                                    <div class="round-arrow-but"></div>
                                    <div class="round-arrow-div">
                                        <img src="../../assets/cloudProduct/arrow.png" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="cooperation-box" v-img="{ form: form.seventhObj, key: 'img' }" :style="'background-image: url(' + form.seventhObj.img + ')'">
                <div class="container1" @click.stop>
                    <div class="cooperation-content">
                        <div class="cooperation-text">
                            <p class="cooperation-text-title font36" v-edit="{ form: form.seventhObj, key: 'title' }">{{ form.seventhObj.title }}</p>
                            <p class="cooperation-text-tips font18" v-edit="{ form: form.seventhObj, key: 'content' }">{{ form.seventhObj.content }}</p>
                        </div>
                        <div class="contact-img">
                            <img src="../../assets/cloudHome/contact.png" />
                            <img v-img="{ form: form.seventhObj, key: 'contactCode' }" style="width:100px;height:100px" :src="form.seventhObj.contactCode" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <submit-form :form="form" :refComponentId="162" :id="137"></submit-form>
        <guidance :type="2" :show="show" @hiddenToggle="hiddenToggle"></guidance>
    </div>
</template>

<script>
import navBar from '../../components/cloudNavBar.vue';
import { initWow } from '@/utils/wow';
import { pageQuery } from '@/api';
import submitForm from '../../components/submit-form.vue';
import itemAdd from '../../components/item-add.vue';
import Guidance from '@/components/guidance.vue';

export default {
    name: '',
    data() {
        return {
            show: false,
            activeName: '0',
            managementTool: '可视化战略布局',
            bigData: '城市宏观数据分析',
            fitModel: '网规模型',
            domShow: false,
            hezuo: {
                src: require('../../assets/cloudHome/contact_bg.jpg')
            },
            form: {
                // bannerObj:{
                // 	img:require('../../assets/cloudProduct/banner_pro.jpg'),
                // 	title:'数字化连锁拓店管理系统',
                // 	smallTitle:'数字化连锁拓店管理系统',
                // 	content:'为连锁品牌提供拓店管理一站式服务：面向企业决策者，通过数据+算法模型，提供开店环节的决策支持；基于开店标准化，提供数字化拓店工具+管理系统，助力实体企业科学开店、高效管理。',
                // 	leftButtonContent:'立即咨询',
                // 	leftButtonPath:'',
                // 	rightButtonContent:'立即咨询',
                // 	rightButtonPath:'',
                // },
                // firstObj:{
                // 	title:'助力品牌拓店全流程数字化ModuleActive',
                // 	content:'提升拓店管理效率，降低门店布局风险',
                // 	list:[{
                // 		img:require('../../assets/cloudProduct/digi_1.png'),
                // 		title:'精准城市布局',
                // 		content:'轻松制定品牌全国拓店计划优化城市门店布局',
                // 		buttonContent:'立即咨询',
                // 	},{
                // 		img:require('../../assets/cloudProduct/digi_2.png'),
                // 		title:'高效精准找铺',
                // 		content:'轻松制定品牌全国拓店计划优化城市门店布局',
                // 		buttonContent:'立即咨询',
                // 	},{
                // 		img:require('../../assets/cloudProduct/digi_3.png'),
                // 		title:'快捷标准勘店',
                // 		content:'轻松制定品牌全国拓店计划优化城市门店布局',
                // 		buttonContent:'立即咨询',
                // 	},{
                // 		img:require('../../assets/cloudProduct/digi_4.png'),
                // 		title:'全面科学评估',
                // 		content:'轻松制定品牌全国拓店计划优化城市门店布局',
                // 		buttonContent:'立即咨询',
                // 	}]
                // },
                // fixedObj:['拓店管理工具','全域商业大数据','品牌适配模型'],
                // secoundObj:{
                // 	title:'工具+数据+模型，标准化SaaS系统',
                // 	content:'三大模块赋能品牌规模化拓店',
                // 	smallTitle:'拓店全业务流闭环管理工具',
                // 	list:[{
                // 		img:require('../../assets/cloudProduct/pro_tool_pic.png'),
                // 		title:'可视化战略布局',
                // 		bigTitle:'全景战略布局，开店进度可控',
                // 		list:['可实现品牌门店全局可视化，即时查看年度/季度/月度进度，即时预警项目风险，灵活制定/调整战略方向与目标。','作业流程关键节点在线审批，拓店进度及时跟进；'],
                // 		leftBotton:'立即咨询',
                // 		rightButton:'申请试用',
                // 		list:['战略地图','战略看板']
                // 	},{
                // 		img:require('../../assets/cloudProduct/pro_tool_pic1.png'),
                // 		title:'信息化品牌管理',
                // 		bigTitle:'开店全流程信息化管理，有效沉淀基盘资源',
                // 		list:['可实现品牌门店全局可视化，即时查看年度/季度/月度进度，即时预警项目风险，灵活制定/调整战略方向与目标。','作业流程关键节点在线审批，拓店进度及时跟进；'],
                // 		leftBotton:'立即咨询',
                // 		rightButton:'申请试用',
                // 		list:['战略地图','战略看板']
                // 	},{
                // 		img:require('../../assets/cloudProduct/pro_tool_pic2.png'),
                // 		title:'大数据智能网规',
                // 		bigTitle:'数据化线上作业，高效精准选址找铺',
                // 		list:['可实现品牌门店全局可视化，即时查看年度/季度/月度进度，即时预警项目风险，灵活制定/调整战略方向与目标。','作业流程关键节点在线审批，拓店进度及时跟进；'],
                // 		leftBotton:'立即咨询',
                // 		rightButton:'申请试用',
                // 		list:['战略地图','战略看板']
                // 	},{
                // 		img:require('../../assets/cloudProduct/pro_tool_pic3.png'),
                // 		title:'智能勘店工具',
                // 		bigTitle:'告别蹲点勘测，信息化快捷标准勘店',
                // 		list:['可实现品牌门店全局可视化，即时查看年度/季度/月度进度，即时预警项目风险，灵活制定/调整战略方向与目标。','作业流程关键节点在线审批，拓店进度及时跟进；'],
                // 		leftBotton:'立即咨询',
                // 		rightButton:'申请试用',
                // 		list:['战略地图','战略看板']
                // 	}],
                //
                // },
                // thiredObj:{
                // 	smallTitle:'全域（线上+线下）商业大数据',
                // 	list:[{
                // 		img:require('../../assets/cloudProduct/pro_tool_pic.png'),
                // 		title:'城市宏观数据分析',
                // 		bigTitle:'全国城市数据在线洞察，高效制定品牌布局战略',
                // 		content:'覆盖全国336座城市，超220个数据指标在线查询，包括但不限于城市GDP、产业比重、人口、商业、交通情况等。',
                // 		leftBotton:'立即咨询',
                // 		rightButton:'申请试用',
                // 	},{
                // 		img:require('../../assets/cloudProduct/pro_tool_pic1.png'),
                // 		title:'商圈客群数据分析',
                // 		bigTitle:'区域商业概况即时获取，助力战略布局',
                // 		content:'在线了解周边人口规模、房价、租金、住宅、写字楼、商业店铺、市政规划等。',
                // 		leftBotton:'立即咨询',
                // 		rightButton:'申请试用',
                // 	},{
                // 		img:require('../../assets/cloudProduct/pro_tool_pic2.png'),
                // 		title:'商场业态客流分析',
                // 		bigTitle:'周边商场快速知悉，调研更加省时省力',
                // 		content:'提供品牌门店发展情况、品牌销量分析、品牌深度洞察等信息；同时支持多品牌横向对比，帮助品牌用户进一步决策。',
                // 		leftBotton:'立即咨询',
                // 		rightButton:'申请试用',
                // 	},{
                // 		img:require('../../assets/cloudProduct/pro_tool_pic3.png'),
                // 		title:'外卖订单数据分析',
                // 		bigTitle:'区域外卖经营情况在线获取',
                // 		content:'一键掌握区域外卖分布、口碑评价、外卖订单、热销单品数据，通过外卖热力图找到最火经营区域，制定更优外卖经营策略。',
                // 		leftBotton:'立即咨询',
                // 		rightButton:'申请试用',
                // 	},{
                // 		img:require('../../assets/cloudProduct/pro_tool_pic3.png'),
                // 		title:'竞对&协同对比分析',
                // 		bigTitle:'区域外卖经营情况在线获取',
                // 		content:'一键掌握区域外卖分布、口碑评价、外卖订单、热销单品数据，通过外卖热力图找到最火经营区域，制定更优外卖经营策略。',
                // 		leftBotton:'立即咨询',
                // 		rightButton:'申请试用',
                // 	}],
                //
                // },
                // fourthObj:{
                // 	smallTitle:'个性化品牌精准适配模型',
                // 	list:[{
                // 		img:require('../../assets/cloudProduct/pro_model_pic.png'),
                // 		title:'网规模型',
                // 		bigTitle:'精准测算开店容量，评估还能开多少店',
                // 		content:'通过对目标开店区域的城市、商圈、人口等多个数据维度，结合品牌自身的经营特点，通过机器学习，精准测算目标开店区域的剩余开店容量。',
                // 		leftBotton:'立即咨询',
                // 		rightButton:'申请试用',
                // 	},{
                // 		img:require('../../assets/cloudProduct/pro_tool_pic1.png'),
                // 		title:'选址模型',
                // 		bigTitle:'高效筛选开店位置，轻松知晓在哪开店',
                // 		content:'在线了解周边人口规模、房价、租金、住宅、写字楼、商业店铺、市政规划等。',
                // 		leftBotton:'立即咨询',
                // 		rightButton:'申请试用',
                // 	},{
                // 		img:require('../../assets/cloudProduct/pro_tool_pic2.png'),
                // 		title:'商场业态客流分析',
                // 		bigTitle:'周边商场快速知悉，调研更加省时省力',
                // 		content:'提供品牌门店发展情况、品牌销量分析、品牌深度洞察等信息；同时支持多品牌横向对比，帮助品牌用户进一步决策。',
                // 		leftBotton:'立即咨询',
                // 		rightButton:'申请试用',
                // 	},{
                // 		img:require('../../assets/cloudProduct/pro_tool_pic3.png'),
                // 		title:'外卖订单数据分析',
                // 		bigTitle:'区域外卖经营情况在线获取',
                // 		content:'一键掌握区域外卖分布、口碑评价、外卖订单、热销单品数据，通过外卖热力图找到最火经营区域，制定更优外卖经营策略。',
                // 		leftBotton:'立即咨询',
                // 		rightButton:'申请试用',
                // 	},{
                // 		img:require('../../assets/cloudProduct/pro_tool_pic3.png'),
                // 		title:'竞对&协同对比分析',
                // 		bigTitle:'区域外卖经营情况在线获取',
                // 		content:'一键掌握区域外卖分布、口碑评价、外卖订单、热销单品数据，通过外卖热力图找到最火经营区域，制定更优外卖经营策略。',
                // 		leftBotton:'立即咨询',
                // 		rightButton:'申请试用',
                // 	}],
                //
                // },
                // fifthObj:{
                // 	title:'产品应用蓝图',
                // 	img:require('../../assets/cloudProduct/pro_app_pic.png')
                // },
                // sixthObj:{
                // 	title:'众多行业用户的信赖之选',
                // 	list:[{
                // 		tableTitle:'茶饮咖啡',
                // 		title:'上上参谋用户&nbsp;李先生1',
                // 		smallTitle:'咖啡茶饮&nbsp;/&nbsp;加盟店主',
                // 		img:require('../../assets/cloudProduct/user_photo.png'),
                // 		logo:require('../../assets/cloudProduct/logo_sscm.png'),
                // 		content:'同期开店的朋友给我推荐了上上参谋，作为开店小白，上上参谋的选址推荐很实在的解决了我不知道店要开在哪里的问题，节省我了不少时间。新店已经开张三个月了，生意还不错。顺利的话，等开第二家店的时候，我还会选择参考上上参谋。',
                // 		button:'立即咨询',
                // 	},{
                // 		tableTitle:'连锁便利',
                // 		title:'上上参谋用户&nbsp;李先生2',
                // 		smallTitle:'咖啡茶饮&nbsp;/&nbsp;加盟店主',
                // 		img:require('../../assets/cloudProduct/user_photo.png'),
                // 		logo:require('../../assets/cloudProduct/logo_sscm.png'),
                // 		content:'同期开店的朋友给我推荐了上上参谋，作为开店小白，上上参谋的选址推荐很实在的解决了我不知道店要开在哪里的问题，节省我了不少时间。新店已经开张三个月了，生意还不错。顺利的话，等开第二家店的时候，我还会选择参考上上参谋。',
                // 		button:'立即咨询',
                // 	},{
                // 		tableTitle:'小吃甜点',
                // 		title:'上上参谋用户&nbsp;李先生3',
                // 		smallTitle:'咖啡茶饮&nbsp;/&nbsp;加盟店主',
                // 		img:require('../../assets/cloudProduct/user_photo.png'),
                // 		logo:require('../../assets/cloudProduct/logo_sscm.png'),
                // 		content:'同期开店的朋友给我推荐了上上参谋，作为开店小白，上上参谋的选址推荐很实在的解决了我不知道店要开在哪里的问题，节省我了不少时间。新店已经开张三个月了，生意还不错。顺利的话，等开第二家店的时候，我还会选择参考上上参谋。',
                // 		button:'立即咨询',
                // 	},{
                // 		tableTitle:'速食快餐',
                // 		title:'上上参谋用户&nbsp;李先生4',
                // 		smallTitle:'咖啡茶饮&nbsp;/&nbsp;加盟店主',
                // 		img:require('../../assets/cloudProduct/user_photo.png'),
                // 		logo:require('../../assets/cloudProduct/logo_sscm.png'),
                // 		content:'同期开店的朋友给我推荐了上上参谋，作为开店小白，上上参谋的选址推荐很实在的解决了我不知道店要开在哪里的问题，节省我了不少时间。新店已经开张三个月了，生意还不错。顺利的话，等开第二家店的时候，我还会选择参考上上参谋。',
                // 		button:'立即咨询',
                // 	}]
                // },
                // seventhObj:{
                // 	img:require('../../assets/cloudHome/contact_bg.jpg'),
                // 	title:'想要了解更多信息或寻求商务合作',
                // 	content:'您可以通过以下方式联系我们，我们将为您推荐满足需求的产品，或指派专业的销售顾问为您服务。'
                // }
            }
        };
    },
    mounted() {
        pageQuery({ componentId: '162', current: 1, size: 10 }).then(res => {
            this.form = JSON.parse(res.data.data[0].context);
            this.$nextTick(() => {
                if (this.$route.query.id) {
                    $(window).scrollTop($('#' + this.$route.query.id).offset().top);
                }
                initWow();
            });
            setTimeout(() => {
                let arr = $('#tabMenuLi .text-model');
                $(window).scroll(function() {
                    if ($(window).scrollTop() > $('#cloudHome1').offset().top) {
                        arr.eq(0)
                            .addClass('active-li')
                            .siblings()
                            .removeClass('active-li');
                    }
                    if ($(window).scrollTop() > $('#cloudHome2').offset().top) {
                        arr.eq(1)
                            .addClass('active-li')
                            .siblings()
                            .removeClass('active-li');
                    }
                    if ($(window).scrollTop() > $('#cloudHome3').offset().top) {
                        arr.eq(2)
                            .addClass('active-li')
                            .siblings()
                            .removeClass('active-li');
                    }
                    if ($(window).scrollTop() > $('#cloudHome1').offset().top && $(window).scrollTop() < $('.product-blueprint-box').offset().top - $(window).height() / 2) {
                        $('#tabMenuLi').fadeIn();
                    } else {
                        $('#tabMenuLi').fadeOut();
                    }
                });

                $('#tabMenuLi .text-model').click(function() {
                    console.log($(this).index());
                    if ($(this).index() == 0) {
                        $('body,html').animate({ scrollTop: $('#cloudHome1').offset().top + 2 }, 600);
                    }
                    if ($(this).index() == 1) {
                        $('body,html').animate({ scrollTop: $('#cloudHome2').offset().top + 2 }, 600);
                    }
                    if ($(this).index() == 2) {
                        $('body,html').animate({ scrollTop: $('#cloudHome3').offset().top + 2 }, 600);
                    }
                });

                $('#backToTop').click(e => {
                    $('body,html').animate({ scrollTop: 0 }, 600);
                });

                this.tabHeaderInitialize('trust-of-choice');

                $('#trust-of-choice .el-tabs .el-tabs__item').hover(
                    e => {
                        $(e.currentTarget).click();
                    },
                    e => {}
                );
            }, 500);
        });
    },
    computed: {},
    methods: {
        showToggle() {
            if (this.$store.state.token) return;
            this.show = true;
        },
        hiddenToggle() {
            this.show = false;
        },
        jumpPage(target, way) {
            if (this.$store.state.token) {
                return;
            }
            if (way == 'router') {
                this.$router.push({
                    name: target
                });
            } else if (way == 'a') {
                window.location.href = target;
            }
        },
        tabHeaderInitialize(idName = 'home-user-selection-tabs-box') {
            let dom = $('#' + idName + ' .el-tabs__header .el-tabs__nav-scroll');
            let h = dom.find('.el-tabs__item').innerHeight();
            let w = dom.find('.el-tabs__item').innerWidth();
            dom.append(`<div class="slider" style="height:${h}px;width: ${w}px;background-color: #eb5405;border-radius: 50px;"></div>`);

            dom.find('.el-tabs__item').click(e => {
                let idText = $(e.currentTarget).attr('id');
                let index = idText.split('tab-')[1];
                let sliderDom = $(e.currentTarget)
                    .parent()
                    .next();
                sliderDom.css({
                    transform: `translateX(${w * index}px)`
                });
            });
        }
    },
    components: { navBar, submitForm, itemAdd, Guidance },
    beforeDestroy() {},
    watch: {}
};
</script>

<style scoped lang="less">
@-webkit-keyframes moduleUp {
    0% {
        -webkit-transform: translateY(0);
        transform: translateY(0);
    }

    50% {
        -webkit-transform: translateY(-5px);
        transform: translateY(-5px);
    }

    100% {
        -webkit-transform: translateY(0);
        transform: translateY(0);
    }
}

@-webkit-keyframes spreadAnimation {
    0% {
        transform: scale(1, 1);
        opacity: 0;
    }

    50% {
        transform: scale(1.5, 1.5);
        opacity: 1;
    }

    100% {
        transform: scale(1.7, 1.7);
        opacity: 0;
    }
}

.product-box {
    width: 100%;
    position: relative;

    .but {
        background-color: #ff5d00;
        padding: 16px 40px;
        font-size: 16px;
        border: none;
        border: 1px solid #ff5d00;
        border-radius: 35px;
        color: #fff;
        display: flex;
        align-content: center;
        width: auto;
        transition: all 0.4s;
        align-items: center;
        margin: 42px 0;
        @media @max-lg {
            margin: 30px 0 0;
            font-size: 14px;
            padding: 14px 32px;
        }
        @media @max-md {
            padding: 12px 24px;
        }
        @media @max-xs {
            margin-top: 24px;
            font-size: 12px;
            padding: 12px 16px;
        }
        i {
            display: block;
            margin-left: 10px;
            font-size: 12px;
        }
        &:hover {
            opacity: 0.9;
        }
    }

    .but-blank {
        background: none;
        border: thin solid #fff;
    }

    .yellow-style {
        background: #fff;
        border: thin solid #eb5405;
        color: #eb5405;
    }

    .but-blank:hover {
        border-color: #ff5d00;
        background-color: #ff5d00;
        color: #fff !important;
    }

    .yellow-style:hover {
        border-color: #ff5d00;
        background-color: #ff5d00;
        color: #fff !important;
    }

    .head-box {
        width: 100%;
        height: auto !important;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 90;
        background-color: rgba(255, 255, 255, 1);
    }

    .content {
        width: 100%;
        position: relative;

        .banner-box {
            width: 100%;
            height: 900px;
            box-sizing: border-box;
            overflow: hidden;
            padding-top: 10px;
            background-size: 100% 100%;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            position: relative;
            height: 46.875vw;
            @media @max-md {
                height: 55vw;
            }
            @media @max-xs {
                padding-top: 80px;
                height: 450px;
            }

            .bag {
                position: absolute;
                top: 0;
                left: 0;
                z-index: 1;
                width: 100%;
                height: 100%;
                img {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                    @media @max-xs {
                        width: 300%;
                        // &:nth-child(1){
                        // 	display: none;
                        // }
                    }
                }
            }
            .container1 {
                position: relative;
                z-index: 2;
            }
            .img-text {
                width: 100%;
                // height: 397px;
                display: flex;
                justify-content: space-between;
                align-items: center;

                .left-box {
                    color: #fff;
                    // margin-left: 250px;
                    max-width: 711px;
                    @media @max-lg {
                        max-width: 600px;
                    }
                    .name {
                        // font-size: 50px;
                        letter-spacing: 1px;
                        margin-bottom: 6px;
                    }

                    .tip-text {
                        // font-size: 26px;
                        letter-spacing: 1px;
                        margin-bottom: 12px;
                        @media @max-lg {
                            margin-bottom: 8px;
                        }
                    }

                    .button-box {
                        display: flex;
                        flex-wrap: wrap;
                        .but {
                            margin-bottom: 0;

                            &:nth-child(2) {
                                border-color: #fff;
                                background: transparent;
                                &:hover {
                                    opacity: 0.8;
                                }
                            }
                        }

                        .but:last-child {
                            margin-left: 20px;
                        }
                    }
                }
            }

            .text-box {
                width: 100%;
                height: 158px;
                display: flex;
                justify-content: center;
                align-items: flex-end;
                overflow-x: auto;

                .background {
                    width: fit-content;
                    height: 130px;
                    display: flex;
                    align-items: center;
                    align-content: flex-start;
                    background-color: rgba(34, 37, 47, 0.5);

                    .text {
                        width: 305px;
                        height: 130px;
                        display: flex;
                        flex-direction: column;
                        align-items: flex-start;
                        justify-content: center;
                        box-sizing: border-box;
                        border-right: thin solid #393d47;
                        padding: 0 0 0 36px;
                        color: #fff;
                        flex-shrink: 0;
                        letter-spacing: 1px;

                        .title {
                            font-size: 20px;
                            font-family: 'PingFang-Heavy' !important;
                        }

                        .tips {
                            font-size: 16px;
                            font-family: 'PingFang-Regular' !important;
                        }
                    }

                    .text:last-child {
                        border: none;
                    }

                    .text:hover {
                        height: 158px;
                        position: relative;
                        top: -15px;
                        color: #eb5405;
                        background: url('../../assets/img/b.png');
                        background-size: 100%;
                        padding-top: 30px;
                    }

                    .active-text {
                        height: 158px;
                        position: relative;
                        top: -15px;
                        color: #eb5405;
                        background: url('../../assets/img/b.png');
                        background-size: 100%;
                        padding-top: 30px;
                    }
                }
            }
        }

        .cell-box {
            width: 100%;
            // padding: 119px 0 108px 0;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            background-color: #fff;
            box-sizing: border-box;

            .box-title {
                color: #000;
                // font-size: 40px;
                margin-bottom: 4px;
                text-align: center;
            }

            .tips {
                text-align: center;
                color: #65697f;
                // font-size: 24px;
                margin-bottom: 12px;
            }

            .module-box {
                // width: 100%;
                min-height: 470px;
                display: flex;
                // justify-content: center;
                align-items: center;
                flex-wrap: wrap;
                @media @max-lg {
                    min-height: 400px;
                }
                @media @max-xs {
                    min-height: initial;
                }
                .module {
                    width: calc(25% - 20px);
                    // height: 418px;
                    box-sizing: border-box;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    align-items: center;
                    border-radius: 8px;
                    // flex-shrink: 0;
                    background-color: #fafafa;
                    // margin-right: 20px;
                    margin: 0 10px;
                    padding: 82px 30px 68px 30px;
                    transition: all 0.5s;
                    min-height: 420px;
                    @media @max-lg {
                        // height: 360px;
                        min-height: 360px;
                        padding: 40px 30px;
                    }
                    @media @max-sm {
                        width: calc(50% - 20px);
                        margin-bottom: 20px;
                    }
                    @media @max-xs {
                        width: 100%;
                        // width: calc(50% - 10px);
                        height: auto;
                        margin-bottom: 16px;
                    }
                    @media @min-sm {
                        &:nth-child(4n) {
                            margin-right: 0;
                        }
                    }
                    .m-img {
                        width: 100%;
                        height: 83px;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        margin-bottom: 52px;
                        @media @max-lg {
                            margin-bottom: 30px;
                        }
                        @media @max-sm {
                            margin-bottom: 26px;
                        }
                        @media @max-xs {
                            margin-bottom: 20px;
                        }
                        img {
                            width: auto;
                            height: 83px;
                            object-fit: scale-down;
                            @media @max-lg {
                                height: 60px;
                            }
                            @media @max-sm {
                                height: 36px;
                            }
                            @media @max-xs {
                                // height: 32px;
                            }
                        }
                    }

                    .module-title {
                        color: #333333;
                        // font-size: 25px;
                        margin-bottom: 15px;
                    }

                    .text {
                        // height: 100px;
                        color: #65697f;
                        font-size: 16px;
                        word-break: break-all;
                        text-align: left;
                        display: -webkit-box;
                        -webkit-line-clamp: 2;
                        -webkit-box-orient: vertical;
                        overflow: hidden;
                        // line-height: 26px;
                        line-height: 1.5;
                        text-align: left;
                        // height: 26px*2;
                        // height: 50px;
                        transition: all 0.3s;
                        @media @max-lg {
                            font-size: 14px;
                            // line-height: 24px;
                            // height: 24px*2;
                            // height: 60px;
                        }
                    }

                    .but-box {
                        // height: 50px;
                        height: 0;
                        transition: all 0.3s;
                        margin-top: 0px;
                        // margin-top: 55px;
                        @media @max-sm {
                            display: none;
                        }
                        .but {
                            display: none;
                            margin: 0;
                        }
                    }

                    &:hover {
                        .but-box {
                            height: 50px;
                            margin-top: 45px;
                        }
                        .text {
                            font-size: 18px;
                            @media @max-lg {
                                font-size: 16px;
                            }
                        }
                    }
                }

                .module:last-child {
                    margin-right: 0;
                }
                @media @min-md {
                    .module-hover:hover {
                        // height: 470px;
                        // transform: scaleY(1.12);
                        background-color: #ffffff;
                        box-shadow: 0 0px 16px 0 rgba(204, 204, 204, 0.4);
                        @media @max-lg {
                            // height: 400px;
                        }
                    }
                    .module-hover:hover .but-box .but {
                        display: block;
                    }
                }

                .module-hover:hover .m-img {
                    animation: moduleUp 2s ease forwards;
                }

                .module-hover:hover .module-title {
                    color: #eb5405;
                }
            }
        }

        .tab-menu-ul {
            width: 175px;
            box-sizing: border-box;
            border-radius: 6px;
            background-color: #fff;
            padding: 15px;
            box-shadow: 0 0px 16px 0 rgba(204, 204, 204, 0.4);
            // display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            position: fixed;
            top: calc(80% - 365px);
            left: 30px;
            z-index: 1000;
            display: none;
            @media (max-width: 1420px) {
                display: none !important;
            }

            a {
                text-decoration: none;
            }

            ul {
                padding: 0;
                margin: 0;
                width: 100%;
                li {
                    width: 100%;
                    box-sizing: border-box;
                    padding: 12px 9px;
                    border-radius: 6px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    text-align: center;
                }

                .text {
                    font-size: 18px;
                    color: #999999;
                }

                .size-14 {
                    font-size: 14px;
                }

                .active-li {
                    color: #eb5405;
                    background-color: #ffebe0;
                }

                .arrow-top {
                    margin-top: 20px;
                }
            }
        }

        .tab-show-box {
            width: 100%;
            // padding: 0 0 50px 0;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            background-color: #f8f9fc;
            box-sizing: border-box;
            .container1 {
                @media @max-lg {
                    max-width: 1100px;
                }
                @media (max-width: 1420px) {
                    max-width: 1400px;
                }
            }
            .box-title {
                color: #121826;
                // font-size: 40px;
                margin-bottom: 15px;
                text-align: center;
                font-family: 'PingFang-Heavy' !important;
            }

            .tips {
                color: #5a6779;
                // font-size: 24px;
            }

            .tabs-title {
                color: #333333;
                // font-size: 35px;
                text-align: center;
                margin-top: 89px;
                margin-bottom: 50px;
                // font-family: 'PingFang-Heavy' !important;
                font-size: 35px;
                @media @max-lg {
                    margin-top: 60px;
                    margin-bottom: 32px;
                    font-size: 32px;
                }
                @media @max-md {
                    font-size: 28px;
                }
                @media @max-sm {
                    margin-top: 30px;
                    margin-bottom: 24px;
                }

                @media @max-xs {
                    font-size: 24px;
                }
            }

            .tab-show-content {
                width: 100%;
                display: flex;
                align-items: center;
                box-sizing: border-box;
                // padding-left: 30px;
                // overflow-x: auto;
                // overflow-y: hidden;

                .show-tabs {
                    width: 100%;
                    // width: 1400px;
                    // flex-shrink: 0;
                    // margin-left: 234px;
                    // height: 740px;

                    ::v-deep {
                        .el-tabs {
                            border: none;
                            box-shadow: initial;

                            .el-tabs__header {
                                background-color: #f3f4f8;
                                border-bottom: none;
                                width: 100%;
                                .el-tabs__nav-wrap {
                                    width: 100%;
                                }
                                .el-tabs__nav {
                                    width: 100%;
                                    display: flex;
                                    justify-content: space-between;
                                    align-items: center;

                                    .el-tabs__item {
                                        height: 74px;
                                        line-height: 74px;
                                        flex: 1;
                                        text-align: center;
                                        color: #333333;
                                        font-size: 20px;
                                        box-sizing: border-box;
                                    }
                                }

                                .is-active {
                                    color: #eb5405 !important;
                                    border-top: 3px solid #eb5405;
                                    border-left: none;
                                    border-right: none;
                                }
                                .el-tabs__nav-scroll {
                                    @media @max-sm {
                                        overflow: auto;
                                    }
                                }
                            }

                            .el-tabs__content {
                                padding: 0 0px 0 50px;
                                @media @max-xs {
                                    padding: 0 20px 32px;
                                }
                            }
                        }
                    }

                    .tab-pan-content {
                        box-sizing: border-box;
                        display: flex;
                        flex-wrap: wrap;
                        justify-content: space-between;
                        align-items: center;

                        .text {
                            background-image: url('../../assets/cloudProduct/qu_2.png');
                            background-repeat: no-repeat;
                            background-size: 101px 68px;
                            background-position: 94% 16%;
                            width: 100% - 57.14285%;
                            @media @max-xs {
                                width: 100%;
                                order: 1;
                            }
                            .tab-name {
                                // font-size: 20px;
                                color: #999999;
                                font-family: 'PingFang-Heavy' !important;
                            }

                            .title {
                                max-width: 390px;
                                // font-size: 30px;
                                color: #333333;
                                margin: 25px 0 35px 0;
                                font-family: 'PingFang-Heavy' !important;
                            }

                            .icon-text-box {
                                // min-height: 160px;
                            }

                            .icon-text {
                                display: flex;
                                align-items: baseline;
                                margin-bottom: 8px;

                                img {
                                    width: 12px;
                                    height: auto;
                                    object-fit: scale-down;
                                    margin-right: 15px;
                                }

                                .describe {
                                    max-width: 557px;
                                    font-size: 16px;
                                    color: #65697f;
                                }
                            }

                            .button-box {
                                display: flex;
                                align-items: center;
                                margin-top: 70px;
                                @media @max-lg {
                                    margin-top: 50px;
                                }
                                @media @max-md {
                                    margin-top: 30px;
                                }
                                @media @max-xs {
                                    margin-top: 22px;
                                }
                                .but {
                                    margin-top: 0;
                                }

                                .but:last-child {
                                    margin-left: 18px;
                                }
                            }
                        }

                        .show-img {
                            width: 57.14285%;
                            height: 670px;
                            @media @max-lg {
                                height: 600px;
                            }
                            @media @max-md {
                                height: 500%;
                            }
                            @media @max-xs {
                                width: 100%;
                                height: 260px;
                            }
                            img {
                                width: auto;
                                height: auto;
                                max-width: 100%;
                                max-height: 100%;
                                object-fit: contain;
                            }
                        }
                    }
                }
                .show-tabs .el-tabs__nav-scroll {
                    @media @max-sm {
                        overflow: auto;
                    }
                }
                .personalized-show-tabs {
                    .tab-pan-content {
                        @media @max-lg {
                            padding: 80px 0;
                        }
                        @media @max-sm {
                            padding: 60px 0;
                        }
                    }
                }

                .management-tool {
                    .tab-pan-content {
                        .icon-text-box {
                            // min-height: 200px !important;

                            .icon-text {
                                margin-bottom: 10px;
                            }
                        }
                    }
                }
            }
        }
        .tab-show-box-top-padding {
            // padding: 120px 0 112px 0;
        }

        .product-blueprint-box {
            width: 100%;
            // padding: 110px 0 100px 0;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            background-color: #f7f9fc;
            box-sizing: border-box;
            background-color: #fff;

            .box-title {
                color: #000;
                // font-size: 40px;
                margin-bottom: 15px;
            }

            .product-blueprint-content {
                display: flex;
                align-items: center;
                overflow-x: auto;
                overflow-y: hidden;

                .blueprint {
                    width: 100%;
                    img {
                        max-width: 100%;
                        height: auto;
                        object-fit: scale-down;
                    }
                }
            }
        }

        .tabs-box {
            width: 100%;
            // min-height: 895px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            background: #f8f9fc;
            background-image: url('../../assets/cloudProduct/arrow-b.png');
            background-repeat: no-repeat;
            background-size: 100% 100%;
            .container1 {
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                max-width: 1100px;
            }
            ::v-deep {
                .el-tabs {
                    @media @max-xs {
                        width: 100%;
                        .slider {
                            display: none;
                        }
                    }
                    .el-tabs__header {
                        width: 100%;
                        margin: 0;
                        background-color: rgba(255, 255, 255, 1);
                        border-radius: 30px;

                        .el-tabs__active-bar {
                            display: none;
                            background-color: #eb5405;
                            @media @max-xs {
                                width: 120px !important;
                                margin-left: -10px;
                                display: block;
                                height: 44px;
                                border-radius: 22px;
                                z-index: -1;
                            }
                        }

                        .el-tabs__item {
                            width: 140px;
                            height: auto;
                            box-sizing: border-box;
                            text-align: center;
                            line-height: initial;
                            padding: 18px 35px;
                            color: #c3c3c3;
                            // font-size: 18px;
                            @media @max-lg {
                                padding: 16px 30px;
                            }
                            @media @max-xs {
                                padding: 12px 20px;
                            }
                        }

                        .is-active {
                            color: #fff !important;
                            // background-color: #eb5405;
                            // border-radius: 50px;
                        }
                    }

                    .el-tabs__nav-wrap::after {
                        display: none;
                    }
                }
            }

            .box-title {
                font-size: 40px;
                color: #121826;
                margin-bottom: 15px;
            }

            .tips {
                font-size: 26px;
                color: #5a6779;
                margin-bottom: 35px;
            }

            .fz_cont {
                position: relative;
                overflow: hidden;
                .tabs-content-box {
                    // width: 1100px;
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 100%;
                    opacity: 0;
                    transition: all 0.4s;
                    visibility: hidden;
                    padding: 60px 80px 80px 80px;
                    border-radius: 8px;
                    background-color: #fff;
                    box-sizing: border-box;
                    margin-top: 35px;
                    box-shadow: 0 0px 34px 2px rgba(222, 224, 227, 1);
                    @media @max-lg {
                        padding: 40px 60px 60px;
                    }
                    @media @max-xs {
                        padding: 30px 20px;
                    }
                    .name-logo-box {
                        width: 100%;
                        display: flex;
                        flex-wrap: wrap;
                        justify-content: space-between;
                        align-items: center;

                        .head-portrait {
                            display: flex;
                            justify-content: space-between;
                            align-items: center;
                            @media @max-xs {
                                width: 100%;
                            }
                            .head-portrait-img {
                                width: 100px;
                                height: auto;
                                object-fit: scale-down;
                                @media @max-lg {
                                    width: 80px;
                                }
                                @media @max-xs {
                                    width: 56px;
                                }
                            }

                            .name-introduction {
                                margin-left: 15px;
                                @media @max-xs {
                                    width: calc(100% - 56px);
                                }
                                .name {
                                    // font-size: 24px;
                                    color: #121826;
                                    font-family: 'PingFang-Heavy' !important;
                                }

                                .introduction {
                                    font-size: 16px;
                                    color: #999999;
                                    font-family: 'PingFang-Regular' !important;
                                    @media @max-lg {
                                        font-size: 14px;
                                    }
                                }
                            }
                        }
                        .r-logo-img {
                            width: 200px;
                            overflow: hidden;
                            @media @max-lg {
                                width: 180px;
                            }
                            @media @max-md {
                                width: 80px;
                            }
                            @media @max-xs {
                                display: none;
                            }
                            img {
                                width: 100%;
                                float: left;
                            }
                        }
                    }

                    .introduction-content {
                        width: 100%;
                        min-height: 180px;
                        padding: 64px 28px 0 32px;
                        box-sizing: border-box;
                        text-align: left;
                        font-size: 18px;
                        color: #7d89a1;
                        letter-spacing: 0px;
                        line-height: 1.8em;
                        word-break: break-all;
                        background-image: url('../../assets/cloudProduct/j2.png'), url('../../assets/cloudProduct/j1.png');
                        background-repeat: no-repeat, no-repeat;
                        background-position: 85px 10px, 98.4% 116px;
                        @media @max-lg {
                            font-size: 16px;
                            padding: 30px 26px;
                        }
                        @media @max-xs {
                            font-size: 14px;
                            padding: 26px 0;
                        }
                    }

                    .button-text-box {
                        padding: 0 35px;
                        display: flex;
                        align-items: center;
                        color: #000;
                        font-size: 16px;
                        @media @max-xs {
                            padding: 0;
                        }
                        .round-arrow {
                            width: 60px;
                            height: 60px;
                            border-radius: 100%;
                            display: flex;
                            justify-content: center;
                            align-items: center;
                            margin-left: 10px;
                            position: relative;

                            .round-arrow-but {
                                width: 40px;
                                height: 40px;
                                border: thin solid #f9cdb5;
                                border-radius: 100%;
                                position: absolute;
                                top: 0;
                                bottom: 0;
                                right: 0;
                                left: 0;
                                margin: auto;
                                opacity: 0;
                            }

                            .round-arrow-div {
                                width: 50px;
                                height: 50px;
                                border-radius: 100%;
                                background-color: #eb5405;
                                display: flex;
                                align-items: center;
                                justify-content: center;

                                img {
                                    width: 15px;
                                    height: auto;
                                    object-fit: scale-down;
                                }
                            }
                        }

                        .round-arrow:hover {
                            .round-arrow-but {
                                animation: spreadAnimation 0.8s infinite;
                            }

                            .round-arrow-div {
                                background-color: #da4f00 !important;
                            }
                        }
                    }
                }
                .active {
                    position: relative;
                    visibility: visible;
                    opacity: 1;
                }
            }
        }

        .logo-plate {
            background: #f2f4f6;
            min-height: 785px;
            padding-top: 70px;

            ::v-deep {
                .el-tabs {
                    .el-tabs__header {
                        width: 100%;
                        .el-tabs__item {
                            width: 140px;
                            height: auto;
                            box-sizing: border-box;
                            line-height: initial;
                            padding: 18px 35px;
                            color: #5a6779;
                            font-size: 18px;
                        }
                    }
                }
            }

            .box-title {
                font-size: 40px;
                color: #121826;
                margin-bottom: 15px;
            }

            .tips {
                font-size: 26px;
                color: #5a6779;
                margin-bottom: 35px;
            }

            .tabs-content-box {
                width: auto;
                padding: 20px 25px !important;

                .logo-list {
                    width: 1055px;
                    display: flex;
                    flex-wrap: wrap;
                    align-items: center;
                    align-content: flex-start;

                    img {
                        width: 150px;
                        height: auto;
                        object-fit: scale-down;
                    }
                }
            }
        }

        .cooperation-box {
            width: 100%;
            height: auto;
            background-size: cover;
            // background-size: 100% 100%;
            padding-top: 28px;
            @media @max-xs {
                padding-top: 60px;
            }
            .cooperation-content {
                display: flex;
                flex-wrap: wrap;
                justify-content: space-between;
                align-items: center;
                align-content: flex-start;

                .cooperation-text {
                    max-width: 580px;
                    color: #fff;
                    // padding-left: 10px;
                    letter-spacing: 0;
                    @media @max-xs {
                        text-align: center;
                    }
                    .cooperation-text-title {
                        // font-size: 35px;
                        margin-bottom: 4px;
                        font-family: 'PingFang-Heavy' !important;
                        transform: translateY(-14px);
                    }
                    .cooperation-text-tips {
                        // font-size: 18px;
                        transform: translateY(-14px);
                    }
                }

                .contact-img {
                    position: relative;
                    margin-right: 120px;

                    @media @max-md {
                        margin-right: 60px;
                    }
                    @media @max-sm {
                        margin-top: 60px;
                        margin-right: 0;
                        margin: 60px auto 0;
                    }
                    img {
                        width: 260px;
                        height: auto;
                        object-fit: scale-down;
                        &:nth-child(2) {
                            position: absolute;
                            left: 82px;
                            width: 100px;
                            top: 84px;
                        }
                    }
                }
            }
        }
    }
}
</style>
